import { IconProps } from '@pelckmans/elementis/icons';
import MaterialAudioIcon from '@pelckmans/elementis/icons/material-audio';
import MaterialDialogueIcon from '@pelckmans/elementis/icons/material-dialogue';
import MaterialExerciseDownloadIcon from '@pelckmans/elementis/icons/material-exercise-download';
import MaterialExerciseOnlineIcon from '@pelckmans/elementis/icons/material-exercise-online';
import MaterialImageIcon from '@pelckmans/elementis/icons/material-image';
import MaterialInfoIcon from '@pelckmans/elementis/icons/material-info';
import MaterialMediaIcon from '@pelckmans/elementis/icons/material-media';
import MaterialPresentationIcon from '@pelckmans/elementis/icons/material-presentation';
import MaterialPresentationPresentModusIcon from '@pelckmans/elementis/icons/material-presentation-present-modus';
import MaterialSiteIcon from '@pelckmans/elementis/icons/material-site';
import MaterialTargetIcon from '@pelckmans/elementis/icons/material-target';
import MaterialVideoIcon from '@pelckmans/elementis/icons/material-video';
import MaterialWordListIcon from '@pelckmans/elementis/icons/material-wordlist';
import UserIcon from '@pelckmans/elementis/icons/user';
import classNames from 'classnames';
import { cloneElement, ReactElement } from 'react';

type MaterialIconProps = {
  materialType: 'medialink' | 'user-material' | 'slide-set';
  contentType?: ContentType;
  isUserSlideSet?: boolean;
  className?: string;
  size?: IconProps['size'];
};

export type ContentType = {
  name: string;
  icon?: string;
  iconClassName?: string;
};

export const EXISTING_CLASS_ICONS_TO_ELEMENTIS_MAPPER: Record<string, ReactElement> = {
  'icon-file-audio': <MaterialAudioIcon />,
  'icon-file-image': <MaterialImageIcon />,
  'icon-file-info': <MaterialInfoIcon />,
  'icon-file-media': <MaterialMediaIcon />,
  'icon-download-exercise': <MaterialExerciseDownloadIcon />,
  'icon-file-video': <MaterialVideoIcon />,
  'icon-mediatype-dialogue': <MaterialDialogueIcon />,
  'icon-site': <MaterialSiteIcon />,
  'icon-online-exercise': <MaterialExerciseOnlineIcon />,
  'icon-target': <MaterialTargetIcon />,
  'icon-wordlist': <MaterialWordListIcon />,
  'icon-user-material': <UserIcon />,
  'icon-slide-set': <MaterialPresentationIcon />,
  'icon-p-slide-set': <MaterialPresentationPresentModusIcon />,
};

export function MaterialIcon({ materialType, contentType, className, isUserSlideSet, size = 'sm' }: MaterialIconProps) {
  if (materialType === 'user-material') {
    return <UserIcon size={size} data-testid="icon-user-material" className={className} />;
  }

  if (materialType === 'slide-set') {
    return isUserSlideSet ? (
      <MaterialPresentationIcon size={size} data-testid="icon-slide-set" className={className} />
    ) : (
      <MaterialPresentationPresentModusIcon size={size} data-testid="icon-p-slide-set" className={className} />
    );
  }

  if (contentType?.iconClassName) {
    return cloneElement(EXISTING_CLASS_ICONS_TO_ELEMENTIS_MAPPER[contentType?.iconClassName], {
      size,
      'data-testid': contentType?.iconClassName,
      className,
    });
  }

  return contentType?.icon ? (
    <img src={contentType.icon} alt={contentType.name} className={classNames('material-icon-image', className)} />
  ) : (
    <MaterialMediaIcon size={size} data-testid="icon-file-media" className={className} />
  );
}
